export const DEFAULT_FILE_ACCEPTED_TYPES = {
    'image/*': ['.png', '.jpg', '.jpeg', '.tiff', '.tif', '.bmp'],
};

export const DEFAULT_FILE_MAX_SIZE = 5 * 1024 * 1024;

export function formatBytes(bytes: number) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
